globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};

appCustomerSpace.Modals.AppointmentCalendly = (function(superClass)
{
  utils.extend(AppointmentCalendly, superClass);

  function AppointmentCalendly($html) {
    this.$html = $html;
    return AppointmentCalendly.__super__.constructor.apply(this, arguments);
  }

  $.extend(AppointmentCalendly.prototype, {
    init: function() {
      var _this   = this;
      CalendlyModule.initWidgets(_this.$html);
      AppointmentCalendly.__super__.init.apply(this, arguments);
    }
  });

  return AppointmentCalendly;
})(appCustomerSpace.Modal);
